import { RcFile } from "antd/lib/upload/interface";

export async function fileToUint8Array(file: RcFile): Promise<Uint8Array> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = () => resolve(new Uint8Array(reader.result as ArrayBuffer));
    reader.onerror = (error) => reject(error);
  });
}
